import { GetStaticPaths, GetStaticProps, NextPage } from 'next';

import {
  RouteHandlerProps,
  RouteHandlerRecord,
  RouterHandlerComponentProps,
} from '@/router/types.router';

export const buildGetStaticPaths: (
  handlers: RouteHandlerRecord
) => GetStaticPaths = (handlers) => async (context) => {
  const paths = await Promise.all(
    Object.values(handlers).map((handler) => handler.getStaticPaths(context))
  );

  return {
    paths: paths.map((path) => path.paths).flat(),
    fallback: 'blocking',
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const injectHandler = (handlerName: string, staticPropsResult: any) => ({
  ...staticPropsResult,
  props: {
    ...staticPropsResult.props,
    handlerName,
  },
});
export const buildGetStaticProps: (
  handlers: RouteHandlerRecord
) => GetStaticProps = (handlers) => async (context) => {
  let latestProps;
  for (const handlerName in handlers) {
    const handler = handlers[handlerName];
    if (!handler) {
      continue;
    }

    if (handler.getStaticProps) {
      latestProps = injectHandler(
        handlerName,
        await handler.getStaticProps(context)
      );
      if (latestProps && !latestProps.notFound) {
        return latestProps;
      }
    }
  }

  return latestProps;
};

export const buildPage: (
  handlers: RouteHandlerRecord
) => NextPage<RouterHandlerComponentProps> =
  (handlers) =>
  ({ handlerName, ...props }: RouterHandlerComponentProps) => {
    const { Component } = handlers[handlerName] as RouteHandlerProps;

    return <Component {...props} />;
  };
